const getters = {
  isLoading: state => state.isLoading,
  list: state => state.list,
  isTransporterListLoading: state => state.isTransporterListLoading,
  transporterWallet: state => state.transporterWallet,
  page: state => state.page,
  hasEmpty: state => state.hasEmpty,
};
export default getters;
